import { JobFilter } from './jobfilter';

export class JobFilterWrapper {

    public candidatePlacementTypes: JobFilter[] = [];
    public sortingOptions: JobFilter[] = [];
    public industryVerticals: JobFilter[] = [];
    public datePosted: JobFilter[] = [];
    public jobSkills: JobFilter[] = [];
    public customFilters: JobFilter[] = [];
    public jobTags: JobFilter[] = [];
}
